import React from 'react';

class AudioErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Suppress audio loading errors from showing as uncaught
        return { hasError: false }; // Don't update UI, just catch the error
    }

    componentDidCatch(error, errorInfo) {
        // Silently catch audio errors - they're already handled by toast notifications
        if (error?.message?.includes('no supported source') ||
            error?.message?.includes('Failed to load') ||
            error?.message?.includes('MEDIA_')) {
            console.warn('[AudioErrorBoundary] Caught audio error:', error.message);
            return;
        }
        // Re-throw other errors
        console.error('[AudioErrorBoundary] Uncaught error:', error, errorInfo);
    }

    render() {
        return this.props.children;
    }
}

export default AudioErrorBoundary;
